import styled from 'styled-components';
import { CustomBackdropController } from '../../../../../components/backdrop/default/v1';
import { useAnalysisVersionActionsContextHook, useAnalysisVersionValueContextHook } from '../../contexts/AnalysisVersionContext';
import { useStockCycleDatasValueContextHook } from '../../contexts/StockCycleDatasContext';
import { useSettingVariablesValueContextHook } from '../../contexts/SettingVariablesContext';
import { useCustomFetcher } from '../../fetcher/useCustomFetcher';
import { ANALYSIS_VERSIONS, ANALYSIS_VERSION_TABS } from '../../variables/analysisVersions';

const StyledContainer = styled.div`
    padding: 10px 10px 0 10px;
`;

const StyledTabs = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 5px;

    .tab {
        border: 1px solid #e0e0e0;
        border-bottom: none;
        border-radius: 3px 3px 0 0;
        background: #f0f0f0;
        color: #808080;
        font-size: 13px;
        font-weight: 700;
        padding: 10px 20px;
        cursor: pointer;

        &:hover {
            background: #e9ecef;
        }

        &.active {
            background: #fff;
            color: #333;
            box-shadow: 0 -2px 0 0 var(--blueColor1) inset;
        }

        .description {
            margin-top: 3px;
            font-size: 11px;
            font-weight: 500;
            color: #909090;
        }
    }
`;

const StyledPolicy = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px;
    margin-top: 10px;

    .badge {
        padding: 4px 8px;
        background-color: #f0f0f0;
        border-radius: 3px;
        font-size: 11px;
        font-weight: 600;
        color: #606060;
    }
`;

export function WegetAnalysisVersionTabs(props) {
    const analysisVersionValueContextHook = useAnalysisVersionValueContextHook();
    const analysisVersionActionsContextHook = useAnalysisVersionActionsContextHook();
    const analysisVersion = analysisVersionValueContextHook.analysisVersion;

    const stockCycleDatasValueContextHook = useStockCycleDatasValueContextHook();
    const stockCycleDatas = stockCycleDatasValueContextHook.stockCycleDatas;
    const stockCycleDatasMap = stockCycleDatasValueContextHook.stockCycleDatasMap;

    const settingVariablesValueContextHook = useSettingVariablesValueContextHook();
    const settingVariables = settingVariablesValueContextHook.settingVariables;

    const customFetcher = useCustomFetcher();

    const outlierPolicy = stockCycleDatas?.outlierPolicy;

    const handleChangeAnalysisVersion = async (version) => {
        if (version === analysisVersion) {
            return;
        }

        analysisVersionActionsContextHook.analysisVersion.onSet(version);

        // 아직 한번도 분석하지 않았다면 그대로 둔다. (조건이 비어있어 오류 토스트만 뜨게 된다)
        const isAnalyzed = Object.values(stockCycleDatasMap || {}).some(datas => !!datas);
        if (!isAnalyzed || stockCycleDatasMap?.[version]) {
            return;
        }

        CustomBackdropController().showBackdrop();
        await customFetcher.onFetchStockCycleDatas(settingVariables, version);
        CustomBackdropController().hideBackdrop();
    }

    return (
        <>
            <StyledContainer>
                <StyledTabs>
                    {ANALYSIS_VERSION_TABS?.map(tab => {
                        return (
                            <div
                                key={tab.version}
                                className={`tab ${analysisVersion === tab.version ? 'active' : ''}`}
                                onClick={() => handleChangeAnalysisVersion(tab.version)}
                            >
                                <div>{tab.name}</div>
                                <div className='description'>{tab.description}</div>
                            </div>
                        );
                    })}
                </StyledTabs>
                {(analysisVersion === ANALYSIS_VERSIONS.V3 && outlierPolicy) &&
                    <StyledPolicy>
                        <div className='badge'>적용된 판정 정책</div>
                        <div className='badge'>중앙값 배수 {outlierPolicy?.orderQtyMultiplier}</div>
                        <div className='badge'>P90 배수 {outlierPolicy?.highQuantileMultiplier}</div>
                        <div className='badge'>일평균 배수 {outlierPolicy?.dailyRateMultiplier}</div>
                        <div className='badge'>판정 최소 주문건수 {outlierPolicy?.minOrderCountForDetection}</div>
                        <div className='badge'>P90 최소 주문건수 {outlierPolicy?.minOrderCountForHighQuantile}</div>
                    </StyledPolicy>
                }
            </StyledContainer>
        </>
    );
}
